import React from 'react'

import {Link } from 'react-router-dom'



const Second_Pane = () =>  (

    <div className='uk-margin-xlarge-top '>

       <div className=''>
       <h1>Toolbox Residence Minna</h1>
       </div>



       
        </div>


     

  )


export default Second_Pane